import React, { useContext, useEffect, useState } from "react";
import { DropLi, Model, UseForm } from "../../../../hooks";
import { Button, ButtonGroup, Input } from "../../../../controls";
import { CartContext } from "../POS";
import { IconButton, InputAdornment } from "@mui/material";
import { Dialog } from "../../../../layout";
import ViewProd from "../../../Catalog/Product/ViewProduct/ViewProd";
import { AddRounded, RemoveRounded } from "@mui/icons-material";

const CartProdBody = ({ item, setAlert }) => {
  const { setCartData } = useContext(CartContext);
  const { CartProdMdl } = Model();
  const { DiscountTypes } = DropLi();
  const { values, setValues, handleInpChg } = UseForm(CartProdMdl);
  const [showViewProd, setShowViewProd] = useState(false);

  useEffect(() => {
    setValues({ ...item });
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.key]);

  useEffect(() => {
    setValues((j) => ({ ...j, qty: item.qty }));
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.qty]);

  const processDiscount = (disType, discount) => {
    if (item.price) {
      var _disAmt = 0;
      var qty = parseFloat(values.qty || 0);
      var totalPrice = item.price * qty;
      disType === 1
        ? (_disAmt = totalPrice * (parseFloat(discount || 0) / 100))
        : (_disAmt = discount);

      var splrPrice = item.varProd
        ? item.varProd.splrPrice
        : item.prod
        ? item.prod.splrPrice
        : 0;
      var totalSplrPrice = splrPrice * qty;

      // if discount price is less then supplier price then give warning
      _disAmt > totalSplrPrice
        ? setAlert({
            isOpen: true,
            type: "confirmation",
            title: "Warning: High Discount",
            subTitle:
              "This discount exceeds the supplier price and could result in a financial loss. Are you sure you want to proceed?",
            onConfirm: () => {
              updateCartItem("disAmt", _disAmt);
              setAlert({
                isOpen: false,
                type: "",
                title: "",
                subTitle: "",
              });
            },
            onCancel: () => {
              updateCartItem("discount", "");
              updateCartItem("disAmt", "");
              setValues((j) => ({ ...j, discount: "", disAmt: "" }));
              setAlert({
                isOpen: false,
                type: "",
                title: "",
                subTitle: "",
              });
            },
          })
        : updateCartItem("disAmt", _disAmt);
    }
  };

  const updateCartItem = (name, value) => {
    setCartData((j) => ({
      ...j,
      sellItems: [
        ...j.sellItems.map((x) =>
          x.key === item.key ? { ...x, [name]: value } : x
        ),
      ],
    }));

    if (name === "qty") updateTotalPrice(parseFloat(value || 0));
    else if (name !== "note") updateTotalPrice();
  };

  const updateTotalPrice = (qty) => {
    setCartData((j) => ({
      ...j,
      sellItems: [
        ...j.sellItems.map((x) => ({
          ...x,
          totalPrice: x.price * parseFloat(qty || x.qty) - (x.disAmt || 0),
        })),
      ],
    }));
  };

  const handleSkipInvError = () => {
    setCartData((j) => ({
      ...j,
      sellItems: j.sellItems.map((x) =>
        x.key === item.key ? { ...x, outOfStock: false } : x
      ),
    }));
  };

  return (
    <>
      <div className="grid gap-[15px] ml-[28px]">
        <div className="flex gap-[10px]">
          <Input
            placeholder="Quantity"
            name="qty"
            value={values.qty}
            type="number"
            variant="outlined"
            size="small"
            onBlur={(e) => updateCartItem(e.target.name, e.target.value || 0)}
            onChange={handleInpChg}
            error={
              item.outOfStock ? (
                <span>
                  {item.invMsg}{" "}
                  <span
                    onClick={() => handleSkipInvError(item.key)}
                    className="underline font-medium hover:cursor-pointer"
                  >
                    Continue anyway?
                  </span>
                </span>
              ) : (
                ""
              )
            }
            sx={{
              ".MuiInputBase-input": {
                borderRight: "1px solid #ddd",
                borderLeft: "1px solid #ddd",
                paddingLeft: "5px",
                textAlign: "center",
              },
              "& .MuiInputBase-root": {
                paddingRight: "3px",
                paddingLeft: "4px",
              },
              "& input[type=number]": {
                MozAppearance: "textfield", // Firefox
              },
              "& input[type=number]::-webkit-outer-spin-button": {
                WebkitAppearance: "none",
                margin: 0,
              },
              "& input[type=number]::-webkit-inner-spin-button": {
                WebkitAppearance: "none",
                margin: 0,
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <IconButton
                    size="small"
                    onClick={() =>
                      updateCartItem(
                        "qty",
                        Math.max(0, parseFloat(values.qty || 0) - 1)
                      )
                    }
                  >
                    <RemoveRounded />
                  </IconButton>
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() =>
                      updateCartItem("qty", parseFloat(values.qty || 0) + 1)
                    }
                  >
                    <AddRounded />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {/* <Input
            placeholder="Price"
            name="price"
            value={values.price}
            type="number"
            variant="outlined"
            size="small"
            onBlur={CalculatePercent}
            onChange={handleInpChg}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          /> */}
          <Input
            placeholder="Discount"
            name="discount"
            value={values.discount}
            type="number"
            variant="outlined"
            size="small"
            onBlur={(e) => {
              updateCartItem(e.target.name, e.target.value);
              processDiscount(values.disType, e.target.value);
            }}
            onChange={handleInpChg}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <ButtonGroup
                    value={values.disType || 0}
                    onChange={(e) => {
                      handleInpChg(e);
                      updateCartItem(e.target.name, e.target.value);
                      processDiscount(e.target.value, values.discount);
                    }}
                    size="small"
                    name="disType"
                    options={DiscountTypes}
                  />
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiInputBase-root": {
                paddingRight: "3px",
              },
            }}
          />
        </div>
        <Input
          note="Note"
          name="note"
          value={values.note}
          variant="outlined"
          size="small"
          multiline
          rows={2}
          onBlur={(e) => updateCartItem(e.target.name, e.target.value)}
          onChange={handleInpChg}
        />
        <Button
          size="small"
          variant="text"
          onClick={() => setShowViewProd(!showViewProd)}
        >
          Show Inventory & Details
        </Button>
      </div>

      {/* View Product */}
      {showViewProd && (
        <Dialog show={showViewProd} onClose={false} maxWidth="lg">
          <ViewProd {...{ setShowForm: setShowViewProd, id: item.prodId }} />
        </Dialog>
      )}
    </>
  );
};

export default CartProdBody;
